export interface DatafeedProvider {
  id: number;
  name: string;
}

export enum DatafeedProviders {
  NotSet = 0,
  Csv = 1,
  Factal = 3,
  Email = 4,
  LifeRaft = 5,
  Wildfires = 6,
  WeatherAlerts = 7,
  Earthquakes = 8,
  GeoJson = 9,
  WorldAwareIntelV2 = 10,
  WorldAwareGeospatialThreatZonesV1 = 11,
  WorldAwareIncidentReportsV1 = 12,
  Ftp = 13,
  Citizen = 14,
  NC4Email = 15,
  ISOSEmail = 16,
  TropicalCyclones = 17,
  TerrorismTrackerIncidents = 18,
  TerrorismTrackerPlots = 19,
  SIASIntelligenceReports = 20,
  SIASRiskRatings = 21,
  SIASTravelAlerts = 22,
  WorldAwareHSARsV2 = 24,
  WorldAwareCSARsV2 = 25,
  WorldAwareJourneysV1 = 26,
  WorldAwareAssignmentsV1 = 27,
  AgentVmsIntegration = 28,
  LifeRaftEmail = 29,
  DataminrEmail = 30,
  Shapefile = 31,
  Genea = 32,
  TitanHST = 33,
  TravelBankEmail = 34,
  DSXEmail = 35,
  PraedictixEmail = 36,
  AvigilonACM = 37,
  MAXSecurityAlerts = 38,
  Envoy = 39,
  WorldAwareLocationsV1 = 40,
  EverbridgeContacts = 41,
  ControlRisksIncidents = 42,
  ControlRisksMaritimeIncidents = 43,
  ControlRisksCountryRiskRatings = 44,
  ControlRisksUpdateArticles = 45,
  TamC = 46,
  TwentyFourSevenInboundIncidents = 47,
  LifeRaftFusion = 48,
  LifeRaftDarkWeb = 49,
  LifeRaftFollowings = 50,
  PushDocuments = 51,
  MitkatRiskTrackerAlerts = 52,
  OpenEyeAlarms = 53,
  OpenEyeCameras = 54,
  OpenEyeRecorders = 55,
  OverhaulEmail = 56,
  ConcurTravelItineraries = 57,
  PowerOutage = 58,
  ISOSItineraries = 59,
  SavoyaItineraries = 60,
  ISOSAlerts = 61,
  OverhaulWebhook = 62,
  ResolverOutbound = 63,
  FedExEdi = 64,
  ProWatchAlarms = 65,
  Kml = 66,
  Dsx = 67,
  Flightradar24Alerts = 68,
  OnSolveRiskIntelligence = 69,
  LenelS2Alarms = 70,
  Dmp = 71,
  CCure = 72,
  Dataminr = 73,
  Crisis24GwtsJourneys = 74,
  ImportUsers = 75,
  BgisImport = 76,
  PowerOutageV2 = 77,
  SamsaraVehicle = 78,
  Vizzion = 79,
  SamsaraVehicleAlerts = 80,
  SamsaraVehicleAlertsPush = 87,
  SamsaraVehicleDrivers = 81,
  WinTeamEmployees = 82,
  WinTeamJobs = 83,
  WinTeamSchedules = 84,
  WinTeamTimePunches = 85,
  MonitorTopoOneDataset = 86,
  XAssistSites = 88,
  PolestarRigs = 89,
  General = 90,
  XAssistPeople = 91,
  OrganizationHierarchy = 92,
  SecurityFiltersImport = 93,
  GuardMetricsTours = 109,
  GuardMetricsIncidents = 110,
  GuardMetricsLocationHistory = 111,
  TrackforceIncidents = 112,
  TrackforceTourAlerts = 113,
  TrackforceLocationHistory = 114,
  TrackforceLoneworkerAlerts = 115,
  GardaWorldDynamicsContacts = 116,
  GardaWorldDynamicsLocations = 117,
  TrackforceVisitors = 118,
  ActiveDirectoryEmployees = 119,
  DeleteUsers = 121,
  LiveViewCameras = 200,
  DataExport = 260,
  WorldAwareJourneysJson = 261,
  GenetecAreas = 301,
  GenetecCameras = 302,
  GenetecDoors = 303,
  GenetecCardholders = 304,
  GenetecEvents = 305,
  GenetecAcknowledgeAlarm = 306,
  Fusion = 350,
  SamsaraVehicleDriversSafetyScores = 500,
  SamsaraVehicleDriversFetchDataset = 501,
  SamsaraVehiclesSafetyScores = 501,
  HorizonOrganization = 801,
  HorizonPerson = 802,
  HorizonUser = 803,
  HorizonLocation = 804,
  HorizonLocationBackFill = 805,
  HorizonAirline = 806,
  HorizonAirlineBackFill = 807,
  HorizonItinerary = 808,
  HorizonAlert = 809,
  HorizonIncident = 810,
  HorizonCategory = 811,
  HorizonMobileCheckIn = 812,
  HorizonUserBackFill = 813,
  HorizonLocationIntelAndRatings = 814,
  HorizonGeospatialThreatZone = 815,
  SevenP = 816,
  ScepterIncidents = 817,
  GeneaAcknowledgeAlarm = 818,
  HorizonPersonCheckIn = 819,
  HorizonCustomRatingScales = 820,
  HorizonCustomRating = 821,
  TotalVoiceCalls = 822,
  SevenPAlerts = 823,
  OrganizationMetrics = 999
}

export const Providers: DatafeedProvider[] = [
  {
    id: DatafeedProviders.Csv,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.Csv}`
  },
  {
    id: DatafeedProviders.Factal,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.Factal}`
  },
  {
    id: DatafeedProviders.Email,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.Email}`
  },
  {
    id: DatafeedProviders.LifeRaft,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.LifeRaft}`
  },
  {
    id: DatafeedProviders.Wildfires,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.Wildfires}`
  },
  {
    id: DatafeedProviders.WeatherAlerts,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.WeatherAlerts}`
  },
  {
    id: DatafeedProviders.Earthquakes,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.Earthquakes}`
  },
  {
    id: DatafeedProviders.GeoJson,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.GeoJson}`
  },
  {
    id: DatafeedProviders.WorldAwareIntelV2,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.WorldAwareIntelV2}`
  },
  {
    id: DatafeedProviders.WorldAwareGeospatialThreatZonesV1,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.WorldAwareGeospatialThreatZonesV1}`
  },
  {
    id: DatafeedProviders.WorldAwareIncidentReportsV1,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.WorldAwareIncidentReportsV1}`
  },
  {
    id: DatafeedProviders.Ftp,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.Ftp}`
  },
  {
    id: DatafeedProviders.Citizen,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.Citizen}`
  },
  {
    id: DatafeedProviders.NC4Email,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.NC4Email}`
  },
  {
    id: DatafeedProviders.ISOSEmail,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.ISOSEmail}`
  },
  {
    id: DatafeedProviders.TropicalCyclones,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.TropicalCyclones}`
  },
  {
    id: DatafeedProviders.TerrorismTrackerIncidents,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.TerrorismTrackerIncidents}`
  },
  {
    id: DatafeedProviders.TerrorismTrackerPlots,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.TerrorismTrackerPlots}`
  },
  {
    id: DatafeedProviders.SIASIntelligenceReports,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.SIASIntelligenceReports}`
  },
  {
    id: DatafeedProviders.SIASRiskRatings,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.SIASRiskRatings}`
  },
  {
    id: DatafeedProviders.SIASTravelAlerts,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.SIASTravelAlerts}`
  },
  {
    id: DatafeedProviders.WorldAwareHSARsV2,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.WorldAwareHSARsV2}`
  },
  {
    id: DatafeedProviders.WorldAwareCSARsV2,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.WorldAwareCSARsV2}`
  },
  {
    id: DatafeedProviders.WorldAwareJourneysV1,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.WorldAwareJourneysV1}`
  },
  {
    id: DatafeedProviders.WorldAwareAssignmentsV1,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.WorldAwareAssignmentsV1}`
  },
  {
    id: DatafeedProviders.AgentVmsIntegration,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.AgentVmsIntegration}`
  },
  {
    id: DatafeedProviders.LifeRaftEmail,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.LifeRaftEmail}`
  },
  {
    id: DatafeedProviders.DataminrEmail,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.DataminrEmail}`
  },
  {
    id: DatafeedProviders.Shapefile,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.Shapefile}`
  },
  {
    id: DatafeedProviders.Genea,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.Genea}`
  },
  {
    id: DatafeedProviders.TitanHST,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.TitanHST}`
  },
  {
    id: DatafeedProviders.TravelBankEmail,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.TravelBankEmail}`
  },
  {
    id: DatafeedProviders.DSXEmail,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.DSXEmail}`
  },
  {
    id: DatafeedProviders.PraedictixEmail,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.PraedictixEmail}`
  },
  {
    id: DatafeedProviders.AvigilonACM,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.AvigilonACM}`
  },
  {
    id: DatafeedProviders.MAXSecurityAlerts,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.MAXSecurityAlerts}`
  },
  {
    id: DatafeedProviders.Envoy,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.Envoy}`
  },
  {
    id: DatafeedProviders.EverbridgeContacts,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.EverbridgeContacts}`
  },
  {
    id: DatafeedProviders.ControlRisksIncidents,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.ControlRisksIncidents}`
  },
  {
    id: DatafeedProviders.ControlRisksMaritimeIncidents,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.ControlRisksMaritimeIncidents}`
  },
  {
    id: DatafeedProviders.ControlRisksCountryRiskRatings,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.ControlRisksCountryRiskRatings}`
  },
  {
    id: DatafeedProviders.ControlRisksUpdateArticles,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.ControlRisksUpdateArticles}`
  },
  {
    id: DatafeedProviders.TamC,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.TamC}`
  },
  {
    id: DatafeedProviders.TwentyFourSevenInboundIncidents,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.TwentyFourSevenInboundIncidents}`
  },
  {
    id: DatafeedProviders.LifeRaftFusion,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.LifeRaftFusion}`
  },
  {
    id: DatafeedProviders.LifeRaftDarkWeb,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.LifeRaftDarkWeb}`
  },
  {
    id: DatafeedProviders.LifeRaftFollowings,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.LifeRaftFollowings}`
  },
  {
    id: DatafeedProviders.PushDocuments,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.PushDocuments}`
  },
  {
    id: DatafeedProviders.MitkatRiskTrackerAlerts,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.MitkatRiskTrackerAlerts}`
  },
  {
    id: DatafeedProviders.OrganizationMetrics,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.OrganizationMetrics}`
  },
  {
    id: DatafeedProviders.OpenEyeAlarms,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.OpenEyeAlarms}`
  },
  {
    id: DatafeedProviders.OpenEyeCameras,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.OpenEyeCameras}`
  },
  {
    id: DatafeedProviders.OpenEyeRecorders,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.OpenEyeRecorders}`
  },
  {
    id: DatafeedProviders.OverhaulEmail,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.OverhaulEmail}`
  },
  {
    id: DatafeedProviders.ConcurTravelItineraries,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.ConcurTravelItineraries}`
  },
  {
    id: DatafeedProviders.PowerOutage,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.PowerOutage}`
  },
  {
    id: DatafeedProviders.ISOSItineraries,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.ISOSItineraries}`
  },
  {
    id: DatafeedProviders.SavoyaItineraries,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.SavoyaItineraries}`
  },
  {
    id: DatafeedProviders.ISOSAlerts,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.ISOSAlerts}`
  },
  {
    id: DatafeedProviders.WorldAwareJourneysJson,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.WorldAwareJourneysJson}`
  },
  {
    id: DatafeedProviders.OverhaulWebhook,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.OverhaulWebhook}`
  },
  {
    id: DatafeedProviders.ResolverOutbound,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.ResolverOutbound}`
  },
  {
    id: DatafeedProviders.FedExEdi,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.FedExEdi}`
  },
  {
    id: DatafeedProviders.ProWatchAlarms,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.ProWatchAlarms}`
  },
  {
    id: DatafeedProviders.Kml,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.Kml}`
  },
  {
    id: DatafeedProviders.Dsx,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.Dsx}`
  },
  {
    id: DatafeedProviders.Flightradar24Alerts,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.Flightradar24Alerts}`
  },
  {
    id: DatafeedProviders.OnSolveRiskIntelligence,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.OnSolveRiskIntelligence}`
  },
  {
    id: DatafeedProviders.LenelS2Alarms,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.LenelS2Alarms}`
  },
  {
    id: DatafeedProviders.Dmp,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.Dmp}`
  },
  {
    id: DatafeedProviders.CCure,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.CCure}`
  },
  {
    id: DatafeedProviders.Dataminr,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.Dataminr}`
  },
  {
    id: DatafeedProviders.Crisis24GwtsJourneys,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.Crisis24GwtsJourneys}`
  },
  {
    id: DatafeedProviders.ImportUsers,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.ImportUsers}`
  },
  {
    id: DatafeedProviders.BgisImport,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.BgisImport}`
  },
  {
    id: DatafeedProviders.PowerOutageV2,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.PowerOutageV2}`
  },
  {
    id: DatafeedProviders.SamsaraVehicle,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.SamsaraVehicle}`
  },
  {
    id: DatafeedProviders.SamsaraVehicleDrivers,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.SamsaraVehicleDrivers}`
  },
  {
    id: DatafeedProviders.SamsaraVehicleAlerts,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.SamsaraVehicleAlerts}`
  },
  {
    id: DatafeedProviders.SamsaraVehicleAlertsPush,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.SamsaraVehicleAlertsPush}`
  },
  {
    id: DatafeedProviders.XAssistSites,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.XAssistSites}`
  },
  {
    id: DatafeedProviders.PolestarRigs,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.PolestarRigs}`
  },
  {
    id: DatafeedProviders.Vizzion,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.Vizzion}`
  },
  {
    id: DatafeedProviders.HorizonOrganization,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.HorizonOrganization}`
  },
  {
    id: DatafeedProviders.HorizonUser,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.HorizonUser}`
  },
  {
    id: DatafeedProviders.HorizonPerson,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.HorizonPerson}`
  },
  {
    id: DatafeedProviders.HorizonLocation,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.HorizonLocation}`
  },
  {
    id: DatafeedProviders.HorizonLocationBackFill,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.HorizonLocationBackFill}`
  },
  {
    id: DatafeedProviders.HorizonLocationIntelAndRatings,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.HorizonLocationIntelAndRatings}`
  },
  {
    id: DatafeedProviders.HorizonCustomRatingScales,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.HorizonCustomRatingScales}`
  },
  {
    id: DatafeedProviders.HorizonCustomRating,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.HorizonCustomRating}`
  },
  {
    id: DatafeedProviders.HorizonGeospatialThreatZone,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.HorizonGeospatialThreatZone}`
  },
  {
    id: DatafeedProviders.HorizonAirline,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.HorizonAirline}`
  },
  {
    id: DatafeedProviders.HorizonAirlineBackFill,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.HorizonAirlineBackFill}`
  },
  {
    id: DatafeedProviders.DataExport,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.DataExport}`
  },
  {
    id: DatafeedProviders.HorizonItinerary,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.HorizonItinerary}`
  },
  {
    id: DatafeedProviders.WinTeamJobs,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.WinTeamJobs}`
  },
  {
    id: DatafeedProviders.WinTeamEmployees,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.WinTeamEmployees}`
  },
  {
    id: DatafeedProviders.HorizonCategory,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.HorizonCategory}`
  },
  {
    id: DatafeedProviders.HorizonAlert,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.HorizonAlert}`
  },
  {
    id: DatafeedProviders.HorizonIncident,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.HorizonIncident}`
  },
  {
    id: DatafeedProviders.LiveViewCameras,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.LiveViewCameras}`
  },
  {
    id: DatafeedProviders.WinTeamSchedules,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.WinTeamSchedules}`
  },
  {
    id: DatafeedProviders.WinTeamTimePunches,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.WinTeamTimePunches}`
  },
  {
    id: DatafeedProviders.MonitorTopoOneDataset,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.MonitorTopoOneDataset}`
  },
  {
    id: DatafeedProviders.HorizonMobileCheckIn,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.HorizonMobileCheckIn}`
  },
  {
    id: DatafeedProviders.HorizonPersonCheckIn,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.HorizonPersonCheckIn}`
  },
  {
    id: DatafeedProviders.General,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.General}`
  },
  {
    id: DatafeedProviders.OrganizationHierarchy,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.OrganizationHierarchy}`
  },
  {
    id: DatafeedProviders.SevenP,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.SevenP}`
  },
  {
    id: DatafeedProviders.SevenPAlerts,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.SevenPAlerts}`
  },
  {
    id: DatafeedProviders.ScepterIncidents,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.ScepterIncidents}`
  },
  {
    id: DatafeedProviders.GenetecAreas,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.GenetecAreas}`
  },
  {
    id: DatafeedProviders.GenetecCameras,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.GenetecCameras}`
  },
  {
    id: DatafeedProviders.GenetecDoors,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.GenetecDoors}`
  },
  {
    id: DatafeedProviders.GenetecCardholders,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.GenetecCardholders}`
  },
  {
    id: DatafeedProviders.SamsaraVehicleDriversSafetyScores,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.SamsaraVehicleDriversSafetyScores}`
  },
  {
    id: DatafeedProviders.GenetecAreas,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.GenetecAreas}`
  },
  {
    id: DatafeedProviders.GenetecCameras,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.GenetecCameras}`
  },
  {
    id: DatafeedProviders.GenetecDoors,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.GenetecDoors}`
  },
  {
    id: DatafeedProviders.GenetecCardholders,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.GenetecCardholders}`
  },
  {
    id: DatafeedProviders.GenetecEvents,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.GenetecEvents}`
  },
  {
    id: DatafeedProviders.Fusion,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.Fusion}`
  },
  {
    id: DatafeedProviders.GenetecAcknowledgeAlarm,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.GenetecAcknowledgeAlarm}`
  },
  {
    id: DatafeedProviders.GeneaAcknowledgeAlarm,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.GeneaAcknowledgeAlarm}`
  },
  {
    id: DatafeedProviders.GuardMetricsTours,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.GuardMetricsTours}`
  },
  {
    id: DatafeedProviders.GuardMetricsIncidents,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.GuardMetricsIncidents}`
  },
  {
    id: DatafeedProviders.GuardMetricsLocationHistory,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.GuardMetricsLocationHistory}`
  },
  {
    id: DatafeedProviders.SecurityFiltersImport,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.SecurityFiltersImport}`
  },
  {
    id: DatafeedProviders.TrackforceIncidents,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.TrackforceIncidents}`
  },
  {
    id: DatafeedProviders.TrackforceTourAlerts,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.TrackforceTourAlerts}`
  },
  {
    id: DatafeedProviders.TrackforceLocationHistory,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.TrackforceLocationHistory}`
  },
  {
    id: DatafeedProviders.TrackforceLoneworkerAlerts,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.TrackforceLoneworkerAlerts}`
  },
  {
    id: DatafeedProviders.GardaWorldDynamicsContacts,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.GardaWorldDynamicsContacts}`
  },
  {
    id: DatafeedProviders.GardaWorldDynamicsLocations,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.GardaWorldDynamicsLocations}`
  },
  {
    id: DatafeedProviders.TrackforceVisitors,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.TrackforceVisitors}`
  },
  {
    id: DatafeedProviders.ActiveDirectoryEmployees,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.ActiveDirectoryEmployees}`
  },
  {
    id: DatafeedProviders.DeleteUsers,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.DeleteUsers}`
  },
  {
    id: DatafeedProviders.TotalVoiceCalls,
    name: `MANAGEMENT.DATAFEEDS.PROVIDER-TYPE-${DatafeedProviders.TotalVoiceCalls}`
  }
];

export const DatafeedProviderLookup: Record<number, string> = Providers.reduce(
  (acc, { id, name }) => ({
    ...acc,
    [id]: name
  }),
  {}
);
